import { useCallback, useEffect, useState } from 'react';
import PropTypes from 'prop-types';
import { useNavigate, useSearchParams } from 'react-router-dom';
import Container from '@mui/material/Container';
import MKBox from 'components/MaterialKit/MKBox';
import { handleErrorResponse } from 'utils/general';
import { withLoading } from 'utils/hoc';
import { useAuth } from 'contexts/auth';
import { getLocaleMap } from 'utils/locales';
import { createBrand, getAlert, getBrand, updateBrand } from 'api/monitors';
import Button from 'components/Button';
import { Grid } from '@mui/material';
import MKTypography from 'components/MaterialKit/MKTypography';
import InputField, { INPUT_TYPE_TEXTAREA } from 'components/InputField';

const EditBrandSection = ({
  setLoading,
  title_color,
  title_font_size,
  title_font_weight,
  back_button_color,
  back_button_font_color,
}) => {
  const [lm, setLm] = useState({});
  const navigate = useNavigate();

  useEffect(() => {
    getLocaleMap(['labels_edit', 'labels_create'])
      .then((response) => {
        setLm(response);
      });
  }, []);

  const [alert, setAlert] = useState(null);
  const [searchParams] = useSearchParams();
  const { setAuth } = useAuth();
  const alertId = searchParams.get('alert_id');

  const fetchAlertFromApi = useCallback(() => {
    if (!alertId) {
      return Promise.resolve();
    }
    setLoading(true);
    return getAlert(alertId, { $expand: 'contact' })
      .then(({ data }) => {
        setAlert(data);
      })
      .catch((error) => {
        handleErrorResponse(error, setAuth);
      })
      .finally(() => {
        setLoading(false);
      });
  }, [alertId, setAuth, setLoading]);

  useEffect(() => {
    fetchAlertFromApi();
  }, [fetchAlertFromApi]);

  return (
    <MKBox flex={1} py="2rem">
      <Container>
        <div style={{ marginBottom: 10, color: title_color, fontSize: title_font_size, fontWeight: title_font_weight }}>
          {alert && `Alerts > ${alert?.alert}`}
        </div>
        <MKBox display="flex" width="100%" justifyContent="space-between" mb="2rem">
          <Button
            color={back_button_color || 'info'}
            style={{
              border: back_button_color === 'white' && '1px solid black',
              width: '10vw',
            }}
            onClick={() => { navigate(-1); }}
            sx={{
              color: back_button_font_color,
            }}
          >
            Back
          </Button>
        </MKBox>
        <Grid container display="flex" flexDirection="row" alignItems="center" mb="1rem">
          <Grid item xs={3}>
            <MKTypography color="black">
              Alert
            </MKTypography>
          </Grid>
          <Grid item xs={9}>
            <MKTypography color="black">
              {alert?.alert}
            </MKTypography>
          </Grid>
        </Grid>
        <Grid container display="flex" flexDirection="row" alignItems="center" mb="1rem">
          <Grid item xs={3}>
            <MKTypography color="black">
              Contact Name
            </MKTypography>
          </Grid>
          <Grid item xs={9}>
            <MKTypography color="black">
              {alert?.contact?.contact_name}
            </MKTypography>
          </Grid>
        </Grid>
        <Grid container display="flex" flexDirection="row" alignItems="center" mb="1rem">
          <Grid item xs={3}>
            <MKTypography color="black">
              Phone (Whatsapp)
            </MKTypography>
          </Grid>
          <Grid item xs={9}>
            <MKTypography color="black">
              {alert?.contact?.phone}
            </MKTypography>
          </Grid>
        </Grid>
        <Grid container display="flex" flexDirection="row" alignItems="center" mb="1rem">
          <Grid item xs={3}>
            <MKTypography color="black">
              Country
            </MKTypography>
          </Grid>
          <Grid item xs={9}>
            <MKTypography color="black">
              {alert?.contact?.country}
            </MKTypography>
          </Grid>
        </Grid>
        <Grid container display="flex" flexDirection="row" alignItems="center" mb="1rem">
          <Grid item xs={3}>
            <MKTypography color="black">
              Created Date
            </MKTypography>
          </Grid>
          <Grid item xs={9}>
            <MKTypography color="black">
              {alert?.createddate}
            </MKTypography>
          </Grid>
        </Grid>
        <Grid container display="flex" flexDirection="row" alignItems="flex-start" mb="1rem">
          <Grid item xs={3}>
            <MKTypography color="black">
              Raw Message
            </MKTypography>
          </Grid>
          <Grid item xs={9}>
            <InputField
              label=""
              value={alert?.raw_message}
              type={INPUT_TYPE_TEXTAREA}
            />
          </Grid>
        </Grid>
      </Container>
    </MKBox>
  );
};

EditBrandSection.propTypes = {
  setLoading: PropTypes.func,
  title_color: PropTypes.string,
  title_font_size: PropTypes.string,
  title_font_weight: PropTypes.string,
  back_button_color: PropTypes.string,
  back_button_font_color: PropTypes.string,
};

export default withLoading(EditBrandSection);
